import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import './App.css';

import Main from './components/Main';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Education from './components/Education';
import Work from './components/Work';
import Contact from './components/Contact';


class App extends Component {
  render() {
    return (
      <Main>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/about" component={About}/>
          <Route exact path="/skills" component={Skills}/>
          <Route exact path="/experience" component={Experience}/>
          <Route exact path="/education" component={Education}/>
          <Route exact path="/work" component={Work}/>
          <Route exact path="/contact" component={Contact}/>
        </Switch>
      </Main>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/App.js